import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export function BlogListPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data.posts)); }, []);
  return (
    <div className="pt-32 pb-24 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] font-semibold">Blog</div>
          <h1 className="mt-3 text-5xl font-bold text-blue-950 dark:text-white">Travel tips &amp; destination guides</h1>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map(p => (
            <Link data-testid={`blog-${p.slug}`} key={p.slug} to={`/blog/${p.slug}`} className="rounded-3xl overflow-hidden card-lift bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-white/10 block">
              <img src={p.image} alt={p.title} className="h-56 w-full object-cover"/>
              <div className="p-6">
                <div className="text-xs uppercase tracking-widest text-[#D4AF37]">{p.category}</div>
                <h3 className="mt-2 text-xl font-bold text-blue-950 dark:text-white">{p.title}</h3>
                <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
export function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(r => setPost(r.data)); }, [slug]);
  if (!post) return <div className="pt-32 min-h-screen text-center text-slate-500">Loading...</div>;
  return (
    <div className="pt-32 pb-24 bg-white dark:bg-slate-950">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37]">{post.category}</div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-blue-950 dark:text-white">{post.title}</h1>
        <div className="text-sm text-slate-500 mt-3">By {post.author}</div>
        <img src={post.image} alt="" className="mt-8 rounded-3xl w-full h-96 object-cover"/>
        <div className="mt-8 text-lg leading-relaxed text-slate-700 dark:text-slate-200 whitespace-pre-line">{post.content}</div>
      </div>
    </div>
  );
}
